import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import ParentInfo from '../../component/Info/ParentInfo';
import CallInfo from '../../component/CallInfo';

const LeeBomHyang = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김성진♥이봄향 결혼합니다";
    const openDesc = "5월 17일 오후 6시 20분";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/197/thumb.png";

    const placeTelNum = "1661-3303";

    const lng = 126.8368847974;
    const lat = 37.5562637915563;

    const forCar = "[ 서울방면 ]\n가양대교타고 우회전 〉 김포공항방향 〉 발산사거리 좌회전 후 \n우측 분당방면 외곽순환도로(김포공항 방향) \n> 김포공항정문에서 좌회전 〉 시내쪽으로 직진 강남,지방 \n(영동)방면 올림픽대로 발산역지나 직진 \n> 발산사거리에서 우회전 후 우측 인천방면 경인고속도로 \n신월IC(김포동 방향)/발산역 이정표에서 우회전 \n > 발산사거리에서 우회전 후 우측\n\n[ 일산방면 ]\n 경부고속도로 서울(한남대교진입)> 올림픽대로 (김포공항 \n방면) >  가양대교 사거리(발산램프방향) 발산램프 2번째 \n사거리지나 우측 (서부간선도로 끝지점 성산대교 건너지 \n말고 P턴하면 공항로) 남부순환로방면 I 남부순환로 \n> 김포공항 이정표 > 발산사거리 우회전 우측";
    const forBus = "발산역 하차\n·파랑(간선) 1 601,605,642,652\n·초록(지선) | 6629,6630,6632,6642,6643,6645,6657\n·공항버스 | (김포공항)6000, (인천공항)6001,6003,6008\n·일반버스 | 1,2,6,60, 60-3, 66, 69,88,631"
    const forSubway = "5호선(방화행) 발산역 하차 7번출구 도보 2분"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "이순옥의 아들"},
        {bride : "이창식 · 이은자의 딸"}
    ]

    const parentInfo = {
        groom: {
            dad: { name: "", isDeceased: false },
            mom: { name: "이순옥", isDeceased: false },
            role: "아들",
        },
        bride: {
            dad: { name: "이창식", isDeceased: false },
            mom: { name: "이은자", isDeceased: false },
            role: "딸",
        }
    };

    const title = "우리 결혼 합니다"

    const msg1 = "저희 두 사람의 소중한 만남이\n결실을 맺어 혼인의 예를 갖추려 합니다."
    const msg2 = "늘 봄날처럼 밝고\n행복하게 살도록 노력하겠습니다."
    const msg3 = "귀한 걸음 하시어\n축복해 주시면 큰 기쁨이겠습니다"

    const groomAccountList = [
        {
            role: "신랑",
            name: "김성진",
            bank: "농협은행",
            accountNumber : "352-1283-1263-93",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FKymtioEW"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "진용성",
        //     bank: "우리은행",
        //     accountNumber : "1002-861-747904",
        //     isKakao : false
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "이순옥",
        //     bank: "농협은행",
        //     accountNumber : "81513256149680",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "이봄향",
            bank: "농협은행",
            accountNumber : "351-0841-6325-03",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FYpihcP7m"
        }
        // ,{
        //     role: "신부 부",
        //     name: "박광익",
        //     bank: "농협은행",
        //     accountNumber : "574-02-008976",
        //     isKakao : false
        // }
        // ,{
        //     role: "신부 모",
        //     name: "장남옥",
        //     bank: "농협은행",
        //     accountNumber : "211057-51-056271",
        //     isKakao : false
        // }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김성진",
            call: "010-5737-6529"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "전제완",
        //     call: "010-3610-3777"
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "장미경",
        //     call: "010-8601-6911"
        // }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "이봄향",
            call: "010-7923-5595"
        }
        // ,{
        //     role: "신부 부",
        //     name: "박정식",
        //     call: "010-3312-2980"
        // },
        // {
        //     role: "신부 모",
        //     name: "김우영",
        //     call: "010-9674-0014"
        // }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "빨리만나고싶었어",
            brideAnswer: "넌 참 특이했지"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "너무행복해",
            brideAnswer: "넘신나고설레"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "다투면 바로풀자",
            brideAnswer: "서로 배려하자"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "다른여잔 없다",
            brideAnswer: "평생 사랑할게"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "행복하게잘살자",
            brideAnswer: "사랑해 오빠!"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };
    

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.groomNameEn)} groomNameEn={getFirstNameEn(weddingData.brideNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"0px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList2 conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper> */}
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forCar={forCar} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default LeeBomHyang;